<template>
  <div class="client_manage">
    <a-card title="选择商品" :bordered="false">
      <!-- 表格 -->
      <a-table :columns="columns" :dataSource="dataSource" :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}" :loading="loading">
        <span slot="name" slot-scope="text, record">
          <img class="nameimg" :src="record.imgurl" :alt="record.p_name">
          <span>{{ record.p_name }}</span>
        </span>
        <div class="footers" slot="footer">
          <a-button type="primary" @click="onDeliver">发货</a-button>
        </div>
      </a-table>

    </a-card>

    <!-- 发货设置 -->
    <a-modal title="发货设置" v-model="visible" @ok="onHandleOk" :confirmLoading="confirmLoading">
      <div style="height:160px;overflow: overlay;">
        <a-form layout='vertical' :form="form">

          <a-form-item label='快递公司:' :label-col="{ span: 4 }" :wrapper-col="{ span: 12 }">

            <a-select allowClear style="width: 304px;" placeholder="请选择快递公司" v-decorator="['express',{ rules: [{ required: true, message: '请选择快递公司!' }] }]">
              <a-select-option v-for="(item,index) in expressage" :key="index" :value="item.id">{{ item.kuaidi_name }}</a-select-option>
            </a-select>

          </a-form-item>

          <a-form-item label='快递单号:' :label-col="{ span: 4 }" :wrapper-col="{ span: 12 }">

            <a-radio-group @change="onChange" v-decorator="['express_type', { initialValue:'1' }]">
              <a-radio value='1'>手动输入</a-radio>
              <!-- <a-radio value='2'>自动获取</a-radio> -->
            </a-radio-group>

            <a-input v-if="values === '1'" style="width:304px;margin-top: 10px;" v-decorator="['courier_num']"></a-input>
          </a-form-item>

        </a-form>
      </div>
    </a-modal>

  </div>
</template>

<script>
const columns = [
  {
    title:'商品名称',
    key:'id',
    scopedSlots: { customRender: 'name' },
  },
  {
    title:'分类',
    key:'class_name',
    dataIndex:'class_name'
  },
  {
    title:'品牌',
    key:'brand_name',
    dataIndex:"brand_name"
  },
  {
    title:'属性',
    dataIndex:'size'
  },
  {
    title:'价格',
    dataIndex:'p_price'
  },
  {
    title:'数量',
    dataIndex:'num'
  }
]

export default {
  data(){
    return {
      columns,
      dataSource: [],
      express: [],
      expressage: [],
      actionlist: {},
      visible: false,
      selectedRowKeys: [],
      selectedRow: [],
      form: this.$form.createForm(this, { name: 'form_in_modal' }),
      values: '1',
      confirmLoading: false,
      loading: false
    }
  },
  mounted(){
    this.httpInits()
  },
  methods: {
    /**
     * @name 初始页面数据
     */
    httpInits(){
      let { params } = this.$route
      this.loading = true
      this.$request.get('?module=pc_api&action=order&m=deliver_show',{ params }).then(res => {
        let { code, message, data } = res

        if(code === 200){
          if (!data.goods.length) {
            this.$message.warning('所有商品都已进入售后，无商品可发货！');
            setTimeout(() => {
              this.$router.back()
            }, 1500)
            return false;
          }

          Object.assign(this,{
            dataSource: data.goods,
            express: data.express,
            expressage: data.express
          })
        }

        this.loading = false
      })
    },
    /**
     * @name 多选框选中回调
     * */ 
    onSelectChange(selectedRowKeys,selectedRows) {
      Object.assign(this,{
        selectedRowKeys: selectedRowKeys,
        selectedRow: selectedRows
      })
    },
    /**
     * @name 发货
    */
    onDeliver(){
      let { selectedRow } = this

      if(!selectedRow.length){
        this.$message.warning('请选择至少一款产品！')
        return
      }
      this.visible = true
    },
    /**
     * @name 单选选中
     * */ 
    onChange(e){
      let { value }    = e.target
      let { express }  = this

      this.values = value

      if(value === '1'){
        Object.assign(this,{
          expressage: express
        })
      } else {

        Object.assign(this,{
          expressage: [{id: "57", kuaidi_name: "顺丰", type: "shunfeng"}]
        })
      }

    },
    /**
     * @name 确定发货
     */
    onHandleOk(){
      let { expressage, form, selectedRow } = this
      let list,listid,data = null
      this.confirmLoading = true

      form.validateFields((err, values) => {
        if (!err) {

          list = expressage.filter(item => item.id === values.express)
          listid = Array.from(selectedRow, item => item.id )
          if(list.length && listid.length){
            data = {
              id:listid.join(','),
              sNo: this.$route.params.id,
              express_name: list[0].kuaidi_name,
              ...values,
              otype:'yb',
              trade:'3'
            }

            this.httpDeliver(data)

          }
        } else {
          setTimeout(() => {
            this.confirmLoading = false
          },600)
        }
      })
    },
    /**
    * @name 返回
    * */ 
    onGoBack(){
      this.$router.go(-1)
    },
    /**
     * 发货 
     * @param data 发货参数
     */
    httpDeliver(data){
      this.$request.post('?module=pc_api&action=order&m=deliver',data).then(res => {
        let { code, message } = res
        if(code === 200){
          this.$message.success(message)

          setTimeout(() => {
            this.dataSource = []
            this.confirmLoading = false
            this.visible = false
            // this.httpInits()
            this.onGoBack()
          },600)

        } else {
          this.$message.warning(message)
          setTimeout(() => {
            this.confirmLoading = false
          },600)
        }
      })
    }
  }

}
</script>

<style lang="less" scoped>
.client_manage {
  .search {
    padding: 8px 32px;
  }

  .handle {
    padding: 0px 32px;
    padding-bottom: 8px;
    display: flex;
    align-items: center;
  }
}

.footers {
  display: flex;
  justify-content: flex-end;
}

.nameimg {
  width:60px;
  height:60px;
}
</style>